
// SVG Icon: map-data-inactive
export default { id: "terriajs-map-data-inactive" };
export const id = "terriajs-map-data-inactive";
export const name = "map-data-inactive";
